module.exports = __webpack_public_path__ + "static/media/Hospitality_57.4d18b7ff.jpg";